
import React, { useState, useEffect } from "react";
import api from "../services/api";
import { formatParcours } from "../services/aspirantUtils";
import { validateFile, formatFileSize, MAX_FILE_SIZE } from "../utils/fileValidation";

export default function UploadProof() {
  const [file, setFile] = useState(null);
  const [requirementId, setRequirementId] = useState("");
  const [requirements, setRequirements] = useState([]);
  const [fileError, setFileError] = useState("");
  const [fileSize, setFileSize] = useState("");

  useEffect(() => {
    api.get("/requirements").then(res => {
      setRequirements(res.data);
    });
  }, []);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    setFileError("");
    setFileSize("");

    if (!selectedFile) {
      setFile(null);
      return;
    }

    // Valider le fichier
    const validation = validateFile(selectedFile, ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png', 'image/gif']);
    
    if (!validation.valid) {
      setFileError(validation.error);
      setFile(null);
      e.target.value = "";
      return;
    }

    setFile(selectedFile);
    setFileSize(validation.size);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!file || !requirementId) {
      return alert("Veuillez choisir un fichier et une exigence.");
    }

    // Double vérification avant l'envoi
    const validation = validateFile(file);
    if (!validation.valid) {
      setFileError(validation.error);
      return;
    }

    const formData = new FormData();
    formData.append("file", file);
    formData.append("requirement_id", requirementId);

    try {
      const res = await api.post("/proofs", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      alert("✅ Fichier envoyé !");
      setFile(null);
      setRequirementId("");
      setFileSize("");
      setFileError("");
      const fileInput = document.querySelector('input[type="file"]');
      if (fileInput) fileInput.value = "";
    } catch (err) {
      console.error(err);
      const errorMsg = err?.response?.data?.error || "Erreur lors de l'envoi.";
      alert(`❌ ${errorMsg}`);
    }
  };

  return (
  <div className="card shadow-sm border-0 p-4">
  <div className="mb-4 text-center">
    <h4 className="text-primary fw-bold mb-1">
      <i className="bi bi-upload me-2"></i>Envoyer une preuve
    </h4>
    <p className="text-muted mb-0">Sélectionnez une exigence et importez votre fichier PDF.</p>
  </div>

  <form onSubmit={handleSubmit}>
    <div className="mb-3">
      <label className="form-label fw-semibold">
        <i className="bi bi-journal-text me-2 text-primary"></i>Exigence :
      </label>
      <select
        className="form-select shadow-sm"
        value={requirementId}
        onChange={(e) => setRequirementId(e.target.value)}
        required
      >
        <option value="">-- Sélectionner --</option>
        {requirements.map((r) => (
          <option key={r.id} value={r.id}>
            {formatParcours(r.parcours)} - {r.title}
          </option>
        ))}
      </select>
    </div>

    <div className="mb-4">
      <label className="form-label fw-semibold">
        <i className="bi bi-file-earmark-pdf me-2 text-danger"></i>Fichier (PDF, JPG, PNG) :
        <small className="text-muted d-block mt-1 fw-normal">
          Taille maximale : {formatFileSize(MAX_FILE_SIZE)}
        </small>
      </label>
      <input
        type="file"
        className={`form-control shadow-sm ${fileError ? "is-invalid" : ""}`}
        accept=".pdf,.jpg,.jpeg,.png,.gif"
        onChange={handleFileChange}
        required
      />
      {fileError && (
        <div className="invalid-feedback d-block">{fileError}</div>
      )}
      {fileSize && !fileError && (
        <small className="text-success d-block mt-1">
          <i className="bi bi-check-circle me-1"></i>
          Taille du fichier : {fileSize}
        </small>
      )}
    </div>

    <button 
      className="btn btn-primary w-100 shadow-sm" 
      type="submit"
      disabled={!file || !!fileError}
    >
      <i className="bi bi-send-fill me-2"></i>Soumettre la preuve
    </button>
  </form>
</div>

  );
}
